<template>
    <a-modal title="在用型号维护" :visible="true" :width="800" @cancel='layerCancel' @ok="handleOk">
        <div>
            <div>关键件系列型号：
                 <a-popover placement="top">
                    <template slot="content">
                        <p v-if="certificateModel" style="max-width: 800px;word-wrap: break-word;word-break: break-all;overflow: hidden;">{{certificateModel}}</p>
                    </template>
                    <span class="headerContent">{{certificateModel}}</span>
                </a-popover>
            </div>
            <hr>
            
           <p class="title">在用型号 <span style="">{{allList.length}}</span>个</p>
            <div class="table-box" >
              <a-table
                 :columns="columns"
                 :data-source="allList"
                 :rowKey="r => r.No"
                 :pagination = false
                >
                <template slot="name" slot-scope="record" >
                  <a-input :maxLength="100" v-model="record.name"  @blur="handleChange"></a-input>
                </template>
                <template slot="mySpecification" slot-scope="record" >
                  <a-input :maxLength="100" v-model="record.mySpecification"  @blur="handleChange"></a-input>
                </template>
                 <template slot="itemNumber" slot-scope="record" >
                  <a-input :maxLength="20" v-model="record.itemNumber"  @blur="handleChange"></a-input>
                </template>
                <template slot="type" slot-scope="record" >
                  <a-select style="width:100px; " v-model="record.type" @blur="handleChange" >
                    <a-select-option v-for="(item , index) in jianList" :key="index" :value="item.type">
                                {{item.name}}
                   </a-select-option>
                  </a-select>
                </template>
                <template slot="operation" slot-scope="record" >
                  <div>
                    <a-icon  type="minus-circle" style="color:#3385FF;cursor: pointer;margin-left: 10px;font-size: 16px;" @click="delAction(record.No)" />
                  </div>
                </template>
              </a-table>

            </div>
            <p class="add-area"><a-icon style="color:#3385FF;cursor: pointer" type="plus-circle" /><a-button style="padding: 0 10px;" type="link" @click="addAction">添加下一个</a-button></p>
        </div>
    </a-modal>
</template>
<script>

import {bindkeyPieceModel, updatekeyPieceModel} from '@/api/certificate'

const align = 'center'
export default {
  //父组件向子组件传递的值在props里接收，注意左侧名字和父组件里名字保持一致
  props:{
    certificateId: Number,
    keyPieceCertificateId:Number
  }, 
  data() {
    return {
       allList:[],
       jianList: [{'type': '0', 'name': '主检'}, {'type': '1', 'name': '非主检'}, {'type': '2', 'name': '不送检'}],
       certificateModel:'',
       til: '',
       columns: [
        {
          title: "序号",
          dataIndex: "No",
          align,
          width: 60
        },
        {
          title: "在用型号",
          scopedSlots: { customRender: 'name' },
          align,
          width: 150,
        },
        {
          title: "规格参数",
          scopedSlots: { customRender: 'mySpecification' },
          align,
          width: 150,
        },
        {
          title: "物料编号",
          scopedSlots: { customRender: 'itemNumber' },
          align,
          width: 150,
        },
         {
          title: "是否送检",
          scopedSlots: { customRender: 'type' },
          align,
          width: 100,
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'operation' },
          align,
          width: 100,
        }
      ],
      
    }
  },
  watch: {
    
  },
  mounted() {
      // this.getDetailData();
      // this.getSolveSelectData(this.id);
  },
  //一进入弹框就需要调用的接口，切记若有参数，格式this.参数名
  created(){
     this.bindkeyPieceModel(this.certificateId, this.keyPieceCertificateId)
    //  this.updatekeyPieceModel();
  },
  methods: {
    handleChange(value) {
      //  value.target.style.border="none"
      //  value.target.style.display="none"
    },
    //点击确定的回调，点击确定调用更新接口，让新添加的数据显示
    handleOk() {
      this.updatekeyPieceModel();
    },
    //再点击添加下一个的时候，push进数组一行内容且默认为不送检，数组有值则进行序号遍历
    addAction() {
      this.allList.push({'name': '', 'mySpecification': '','itemNumber': '','type': '2',});
      if (this.allList && this.allList.length > 0) {
           this.allList.map((i, index) => {
             i.No = index + 1;
           })
         }
    },
    //实现弹窗关闭的功能，向父组件传值
    layerCancel() {
      this.$emit('hideAction');
    },
    // 成品型号绑定查询
    bindkeyPieceModel(certificateId, keyPieceCertificateId) {
       bindkeyPieceModel(certificateId, keyPieceCertificateId)
        .then((res) => {
          //从接口获取后台传给我的值
         this.certificateModel = res.certificateModel;
         //modelInUses是后台传过来的参数名，并判断它是否有值，有值则进行序号的遍历
         if (res.modelInUses && res.modelInUses.length > 0) {
           res.modelInUses.map((i, index) => {
             i.No = index + 1;
           })
         }
        //res为所有的数据，addList为自定义的 我表格需要渲染的数据
         this.allList = res.modelInUses;
        })
        .catch(error => {
         
        })
    },
    //成品型号更新，
    //添加一条新数据，在成功返回给后端，这需要看后端传给你了几个参数，记住左边参数名就是后台定义的名字，不能改。
    updatekeyPieceModel() {
       let chen = {
        'certificateId': this.certificateId,
        'keyPieceCertificateId': this.keyPieceCertificateId,
        'modelInUses': this.allList
      }
       updatekeyPieceModel(chen)
        .then((res) => {
          //成功时候的调用
          this.$emit('success');
        })
        .catch(error => {
         
        })
    },
    delAction(index) {
        let that = this;
        that.$confirm({
            title: '确定删除该型号吗',
            okText: '确认',
            cancelText: '取消',
            onOk:function () {
              //index-1 删除项目的位置，看客户点第几行，1为删除的个数
                that.allList.map((i, indexs) => {
                  if (i.No == index) {
                    that.allList.splice(indexs, 1);
                  }
                })
            },
            
        })
        
    },
       
  },
}
</script>
<style lang="less" scoped>
    .headerContent{
        line-height: 30px;
        display: inline-block;
        width: 450px;
        overflow: hidden;/*超出部分隐藏*/
        white-space: nowrap;/*不换行*/
        text-overflow:ellipsis;
        vertical-align: middle;
        cursor: pointer;
    }
    .title {
        margin: 15px 0;
        text-align: center;
        font-size: 16px;
        font-weight: 600;
    }
    .select-box {
        margin-top: 10px;
    }
    .table-box{
      max-height: 300px;
      // border: 1px solid pink;
      overflow: auto;
      
    }
   
   
</style>